// extracted by mini-css-extract-plugin
module.exports = {"container":"PageLoadingSpinner_container__3v_YC","progress":"PageLoadingSpinner_progress__IcmfM","dark":"PageLoadingSpinner_dark__3Zo46"};